module.exports = __webpack_public_path__ + "static/assets/9f0eecc2f15f32ee8287decd10ef29a8.png";